//import CreditCardChargesList from "../datasets/credit_card_charges_list";

export const applyToCreditCard = (creditCardInfo, cashExpense, cashDesc, cashCategory, chgType) => {
   
     if (!chgType){
         chgType = "unplanned";
     }
     if (chgType === "unplanned"){ 
            cashExpense = cashExpense * -1;
     }
     creditCardInfo.totalOutstandingBalance = 
              (+creditCardInfo.totalOutstandingBalance +  +cashExpense).toString();
     let indx = creditCardInfo.periodCreditCharges.length - 1;
     let category = cashCategory;
     if (!cashCategory){
            category = "other";
     };  
     let creditObj = {amount: cashExpense, desc: cashDesc, category: category, chgType: chgType};       
     creditCardInfo.periodCreditCharges[indx].creditChargesArr.push (creditObj);
              
    return creditCardInfo;
   
}
